import {
	type FetchSocialInterestTypesData,
	type FetchSocialInterestTypesParams,
	type FetchSocialUserInterestsData,
	type PostSocialUserInterestsPayload,
	type SocialInterest,
	type SocialInterestType,
	type SocialUserInterestDTO
} from '@capsicum/common';
import { useMutation, useQuery } from '@tanstack/react-query';

import { socialApi } from '../api';

export type InterestCategories = Array<
	SocialInterestType & {
		interests?: Array<SocialInterest>;
	}
>;

export const UseUserInterestsQueryKey = {
	getInterests: (params: FetchSocialInterestTypesParams) => ['interests', params],
	getUserInterests: () => ['interests'],
	sendInterests: ['interests', 'send']
};

export const useGetInterests = (options: { enabled?: boolean } = {}, queryParams: FetchSocialInterestTypesParams) => {
	return useQuery<FetchSocialInterestTypesData, unknown, InterestCategories>({
		...options,
		queryFn: async () => (await socialApi).fetchSocialInterestTypes(queryParams),
		queryKey: UseUserInterestsQueryKey.getInterests(queryParams),
		select: (res: FetchSocialInterestTypesData) => res?.data || []
	});
};

export const useGetUserInterests = (options: { enabled?: boolean } = {}) => {
	return useQuery<FetchSocialUserInterestsData, unknown, Array<SocialUserInterestDTO>>({
		...options,
		queryFn: async () => (await socialApi).fetchSocialUserInterests(),
		queryKey: UseUserInterestsQueryKey.getUserInterests(),
		select: res => res?.data || []
	});
};

export const useSendInterests = (options: { enabled?: boolean } = {}) => {
	return useMutation({
		...options,
		mutationFn: async (params: PostSocialUserInterestsPayload) => (await socialApi).postSocialUserInterests(params),
		mutationKey: UseUserInterestsQueryKey.sendInterests
	});
};
